function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5362 7.5C16.5362 7.82277 16.3157 8.03616 16 8.03616C15.6843 8.03616 15.4638 7.82277 15.4638 7.5C15.4638 7.17723 15.6843 6.96384 16 6.96384C16.3157 6.96384 16.5362 7.17723 16.5362 7.5ZM16.5362 15.5C16.5362 15.8228 16.3157 16.0362 16 16.0362C15.6843 16.0362 15.4638 15.8228 15.4638 15.5C15.4638 15.1772 15.6843 14.9638 16 14.9638C16.3157 14.9638 16.5362 15.1772 16.5362 15.5ZM16.5362 23.5C16.5362 23.8228 16.3157 24.0362 16 24.0362C15.6843 24.0362 15.4638 23.8228 15.4638 23.5C15.4638 23.1772 15.6843 22.9638 16 22.9638C16.3157 22.9638 16.5362 23.1772 16.5362 23.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.92768
});

function SvgDotsThreeVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeVertical);
export default __webpack_public_path__ + "static/media/dots-three-vertical.2bcf288e.svg";
export { ForwardRef as ReactComponent };